<template>
  <section class="about-usage-flow">
    <div class="about-usage-flow__content">
      <h3 class="about-usage-flow__title">ご利用の流れ</h3>
      <div class="about-usage-flow__steps-area">
        <div class="about-usage-flow__steps-wrapper">
          <button class="about-usage-flow__navigation--prev">
            <ChevronBack />
          </button>
          <swiper-container
            :modules="[Navigation, Pagination]"
            :slides-per-view="1"
            :space-between="16"
            :breakpoints="{
              1024: {
                slidesPerView: 4,
                spaceBetween: 42
              }
            }"
            :navigation="swiperNavigation"
            :pagination="swiperPagination"
            :loop="true"
            class="step-swiper"
          >
            <swiper-slide>
              <div class="about-usage-flow__step">
                <img
                  class="about-usage-flow__step--image"
                  src="../../../../../../images/bulk_personal_orders/about/usage_flow/step1.svg"
                />
                <div class="about-usage-flow__step-item">
                  <div class="about-usage-flow__step-header--odd">
                    <h3 class="about-usage-flow__step-header--title">
                      1.お申し込み
                    </h3>
                  </div>
                  <div class="about-usage-flow__step-content">
                    <div class="about-usage-flow__step-content--wrapper">
                      <ul>
                        <li>希望ギフト</li>
                        <li>メッセージ</li>
                        <li>差出人名</li>
                        <li>お申し込み者様の情報</li>
                      </ul>
                      <p>など、必要事項をご入力いただきます。</p>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <ChevronForward class="about-usage-flow__next" />
            <swiper-slide>
              <div class="about-usage-flow__step">
                <img
                  class="about-usage-flow__step--image"
                  src="../../../../../../images/bulk_personal_orders/about/usage_flow/step2.svg"
                />
                <div class="about-usage-flow__step-item">
                  <div class="about-usage-flow__step-header--even">
                    <h3 class="about-usage-flow__step-header--title">
                      2.内容の確認
                    </h3>
                  </div>
                  <div class="about-usage-flow__step-content">
                    <div class="about-usage-flow__step-content--wrapper">
                      <p>
                        ギフティにて利用用途や商品在庫を確認し、問題なければご請求書をご入力のメールアドレス宛てに送付します。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <ChevronForward class="about-usage-flow__next" />
            <swiper-slide>
              <div class="about-usage-flow__step">
                <img
                  class="about-usage-flow__step--image"
                  src="../../../../../../images/bulk_personal_orders/about/usage_flow/step3.svg"
                />
                <div class="about-usage-flow__step-item">
                  <div class="about-usage-flow__step-header--odd">
                    <h3 class="about-usage-flow__step-header--title">
                      3.お振り込み
                    </h3>
                  </div>
                  <div class="about-usage-flow__step-content">
                    <div class="about-usage-flow__step-content--wrapper">
                      <p>
                        ギフティ指定の銀行口座に、ご請求金額をお振り込みいただきます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <ChevronForward class="about-usage-flow__next" />
            <swiper-slide>
              <div class="about-usage-flow__step">
                <img
                  class="about-usage-flow__step--image"
                  src="../../../../../../images/bulk_personal_orders/about/usage_flow/step4.svg"
                />
                <div class="about-usage-flow__step-item">
                  <div class="about-usage-flow__step-header--even">
                    <h3 class="about-usage-flow__step-header--title">
                      <span>4.ギフトカードの</span><span>URLを発行</span>
                    </h3>
                  </div>
                  <div class="about-usage-flow__step-content">
                    <div class="about-usage-flow__step-content--wrapper">
                      <p>
                        ギフティにてギフトカードURLを発行し、CSVファイルにまとめて納品いたします。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper-container>
          <button class="about-usage-flow__navigation--next">
            <ChevronForward />
          </button>
        </div>
        <div class="about-usage-flow__dots" />
      </div>
      <div class="about-usage-flow__sample">
        <p class="about-usage-flow__sample--title mb-8">
          実際に納品されるCSVファイルのサンプル
        </p>
        <ImgLazy
          :image-url="SampleCSVImage"
          alt-text="CSVファイルのサンプル"
          aspect-ratio="350 / 71"
          class="about-usage-flow__sample--image"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import ChevronBack from '../../../atoms/svg_icons/ChevronBack.vue'
import ChevronForward from '../../../atoms/svg_icons/ChevronForward.vue'
import SampleCSVImage from '../../../../../../images/bulk_personal_orders/about/sample_csv.png'
import { Navigation, Pagination } from 'swiper/modules'
import { register } from 'swiper/element/bundle'

register()

const swiperNavigation = {
  prevEl: '.about-usage-flow__navigation--prev',
  nextEl: '.about-usage-flow__navigation--next'
}

const swiperPagination = {
  el: '.about-usage-flow__dots',
  clickable: true
}
</script>

<style lang="scss" scoped>
.about-usage-flow {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $gray-3;

  &__content {
    width: 100%;
    max-width: 1440px;
    padding: 86px 72px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 56px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 64px 24px;
    }
  }

  &__title {
    color: $black;
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.6;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
    }
  }

  &__steps-area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    margin: 48px 0;

    @media all and (max-width: ($pc-width - 1)) {
      margin: 32px 0;
    }
  }

  &__steps-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  &__navigation {
    &--prev,
    &--next {
      width: 48px;
      height: 48px;
      fill: $gray-1;
      cursor: pointer;
      flex-shrink: 0;

      @media all and (min-width: ($pc-width)) {
        display: none;
      }
    }
  }

  &__next {
    width: 20px;
    height: 20px;

    @media all and (min-width: ($pc-width)) {
      display: none;
    }
  }

  &__steps {
    @media all and (min-width: ($pc-width)) {
      display: flex;
      gap: 24px;
      align-items: flex-end;
    }
  }

  &__step {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 18px;
    gap: 18px;

    @media all and (min-width: ($pc-width)) {
      display: flex !important; // v-showでdisplay: noneを設定しているcurrentStep以外のstepを表示するため、importantを設定。
    }

    &--image {
      height: 64px;
      object-fit: contain;

      @media all and (max-width: ($pc-width - 1)) {
        height: 48px;
      }
    }

    &-item {
      width: 100%;
    }

    &-header--odd {
      background-color: $primary;
    }

    &-header--even {
      background-color: $brown-1;
    }

    &-header--odd,
    &-header--even {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 103px;
      width: 100%;
      border-radius: 10px 10px 0 0;
    }

    &-header {
      &--title {
        font-weight: bold;
        font-size: 2rem;
        line-height: 1.35;
        text-align: center;
        color: $white;

        @media all and (max-width: ($pc-width - 1)) {
          line-height: 1.7;
        }

        & > span {
          display: block;
        }
      }
    }

    &-content {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $white;
      height: 214px;
      width: 100%;
      border-radius: 0 0 10px 10px;
      padding: 32px;
      box-sizing: border-box;

      @media all and (max-width: ($pc-width - 1)) {
        height: 189px;
      }

      &--wrapper {
        text-align: left;
        font-size: 1.4rem;
        color: $black;
        line-height: 1.79;

        & > ul,
        li {
          list-style: disc;
        }

        & > ul {
          padding-left: 1.4rem;
        }
      }
    }
  }

  &__dots {
    display: flex;
    gap: 8px;
    justify-content: center;

    @media all and (min-width: ($pc-width)) {
      display: none;
    }
  }

  &__sample {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--title {
      font-size: 1.2rem;
      color: $black;
      line-height: 2.08;
    }

    &--image {
      max-width: 810px;
      width: 100%;

      @media all and (max-width: ($pc-width - 1)) {
        max-width: none;
      }
    }
  }
}

swiper-slide {
  position: relative;

  &::before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 20px;
    fill: $gray-1;
    background-image: url('../../../../../../images/bulk_personal_orders/about/slide_next.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    // swiper-slideのmargin（spaceBetween: 42）を元に中央に来るように計算
    right: calc(((42px / 2) + (12px / 2)) * -1);
    // about-usage-flow__step-contentの高さを元に中央に来るように計算
    bottom: calc((214px / 2) - (20px / 2));

    @media all and (max-width: ($pc-width - 1)) {
      &::before {
        content: none;
      }
    }
  }

  &:last-child {
    &::before {
      content: none;
    }
  }
}

swiper-container {
  width: 100%;

  @media all and (max-width: ($pc-width - 1)) {
    // about-usage-flow__contentとpaddingと、左右のabout-usage-flow__navigationのwidthを引く。
    // + 36pxは、Swiperの < と > を外側のPaddingギリギリに揃えるため
    width: calc(100vw - 56px * 2 - 48px * 2 + 36px);
  }

  @media all and (max-width: ($base-contents-width - 1)) {
    // about-usage-flow__contentとpaddingと、左右のabout-usage-flow__navigationのwidthを引く。
    // + 36pxは、Swiperの < と > を外側のPaddingギリギリに揃えるため
    width: calc(100vw - 24px * 2 - 48px * 2 + 36px);
  }
}

swiper-container::part(wrapper) {
  display: flex;
  align-items: flex-end;
}

:deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: $gray-2;
}

:deep(.swiper-pagination-bullet-active) {
  background-color: $gray-1;
}
</style>
